/* eslint-disable camelcase */
import React, { useCallback } from 'react';
import { object, string } from 'prop-types';
import { styled } from '@nextiva/next-ui-components';
import { Card } from 'components/CreateRoleCard/CreateRoleCard';

import { EDIT_ROLE, CLONE_ROLE } from 'constants/drawerTitles';
import { SvgClone } from 'components/SvgIcon';

import { getRoleIcon, numOfUsers } from '../UserRolesGrid/helpers/index';

const Container = styled('div')`
  max-height: 67px;
  width: 100%;
  overflow: hidden;
  border: 1px solid #99adc2;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  &:hover {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.16);
    transform: scale(1.01);
    cursor: pointer;
  }
`;

export const UserRolesCard = ({ role, onClickRoleCardHandler, dataTestId }) => {
  const { name, user_defined, assignedProfilesCount } = role;

  const icon = useCallback(getRoleIcon(role), [name]);
  const users = useCallback(numOfUsers(assignedProfilesCount), [
    assignedProfilesCount,
  ]);

  const onClickHandler = useCallback(() => {
    if (user_defined) {
      onClickRoleCardHandler(role, EDIT_ROLE);

      return;
    }

    onClickRoleCardHandler(role);
  }, [role]);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    onClickRoleCardHandler(role, CLONE_ROLE);
  };

  return (
    <Container
      onClick={onClickHandler}
      data-testid={`PlatformAdminUI-RolesAndPermissions-UserRolesCard-${dataTestId}`}
    >
      <Card className="m-roles-card">
        <div
          className="m-roles-card__icon"
          data-testid="PlatformAdminUI-RolesAndPermissions-UserRolesCard-RoleCardIcon"
        >
          {icon}
        </div>
        <div
          className="m-roles-card__text"
          data-testid="PlatformAdminUI-RolesAndPermissions-UserRolesCard-RoleCardText"
        >
          <div
            className="m-roles-card__name Heading5"
            data-testid="PlatformAdminUI-RolesAndPermissions-UserRolesCard-RoleCardName"
          >
            {name}
          </div>
          <div
            className="m-roles-card__users Caption-Card"
            data-testid={`PlatformAdminUI-RolesAndPermissions-UserRolesCard-${users}`}
          >
            {users}
          </div>
        </div>
        <button
          type="button"
          onClick={onClick}
          className="m-roles-card__clone-btn"
          data-testid="PlatformAdminUI-RolesAndPermissions-UserRolesCard-RoleCardCloneButton"
        >
          <SvgClone />
        </button>
      </Card>
    </Container>
  );
};

UserRolesCard.propTypes = {
  dataTestId: string.isRequired,
  role: object.isRequired,
};

export default UserRolesCard;
